import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { FlatFileModel} from '../models/flatfile.model';
import { WebJobQueueModel } from '../models/webJobQueue.model';
import { InfraService } from './infra.service';

@Injectable()
export class WebJobQueueService {
  private coreAPIUrl: string;
  constructor(private infraService:InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {
      this.coreAPIUrl = data.WebEndPoint2 + 'WebJobQueue';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') !== undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }

    // if (localStorage.getItem('selectedregion') == '1') {
    //   this.coreAPIUrl = environment.coreUrl + 'WebJobQueue';
    // } else {
    //   this.coreAPIUrl = environment.coreRowUrl + 'WebJobQueue';
    // }
  }

  public getWebJobQueue(engagementId: number):Observable<WebJobQueueModel> {
    return this.http.get<WebJobQueueModel>(`${this.coreAPIUrl}/${engagementId}`);
    // .catch(this.handleError);
  }

  private handleError(error: Response) {
    return throwError(()=> error);
  }
}
